import MobileHeaderSidebar from './views/MobileHeaderSidebar';

export default MobileHeaderSidebar;